import { render, staticRenderFns } from "./index.vue?vue&type=template&id=07cd6cac&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=07cd6cac&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07cd6cac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/重构-快递前端-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07cd6cac')) {
      api.createRecord('07cd6cac', component.options)
    } else {
      api.reload('07cd6cac', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=07cd6cac&scoped=true", function () {
      api.rerender('07cd6cac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/resource/newDictType/index.vue"
export default component.exports